module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/image-ecc807d585393db302be553b7c1766b3.png";